<template>
    <div>
      <div class="quotas">
        <div class="rangesList">
          <div v-for="(quota, index) in quotas" :class="getQuotaDivClass(quota, index)" class="field quota">
            <div class="is-inline-block gender">
              <vb-switch type="danger rounded" size="medium" v-model="quota.gender"/>
            </div>
            <div class="is-inline-block age">
              <vue-slider v-model="quota.age" :tooltip="'always'" :tooltip-placement="['top', 'top']" :contained="true"  :max="quotasParam.maxAge" :marks="quotasParam.marks"
                            :railStyle="getSliderRailStyle(quota)"  :tooltipStyle="getSliderTooltipStyle(quota)"     :processStyle="getSliderProcessStyle(quota)">
              </vue-slider>
              <div class="field highLimit">
                <div class="control">
                  <label class="checkbox">
                    <span>{{$t('campaigns.quotas.noLimit')}}</span>
                    <input type="checkbox" v-on:change="toggleHighLimit(!this.event.target.checked, quota)" :checked="!isRange(quota.age)">
                  </label>
                </div>
              </div>
            </div>
            <div class="control is-inline-block limit">
              <input class="input" type="number" placeholder="limit" v-model="quota.limit" min="0">
            </div>
            <div class="control is-inline-block summary">
              <span>{{getQuotaSummary(quota)}}</span>
            </div>
          </div>
          <button class="button is-rounded" v-on:click="addQuota()"><i class="fas fa-plus-circle"/>{{$t('campaigns.quotas.addQuotas')}}</button>
        </div>
      </div>
      <button class="button is-primary save" v-on:click="saveQuotas()">
        <span class="icon">
          <i class="fa fa-floppy-o"></i>
        </span>
        <span>{{$t('common.actions.save')}}</span>
      </button>
    </div>
</template>

<script>
    import VisCommon from '../../components/VisCommon'
    import VueSlider from 'vue-slider-component'
    import {Collapse, Item as CollapseItem} from 'vue-bulma-collapse'
    import VbSwitch from 'vue-bulma-switch'
    import 'vue-slider-component/theme/default.css'


    const QUOTAS_API = '/quota'

    export default {
        name: 'CampaignQuota',
        extends: VisCommon,
        components: {
          VueSlider,
          Collapse,
          CollapseItem,
          VbSwitch
        },
        props: ['campaignId'],
        data: function () {
          return {
              quotas: [],
              quotasParam: {
                maxAge:100,
                marks: val => val % 10 === 0
              }
          }
        },
        created() {
          this.loadQuotas()
        },
        methods: {
          setQuotas(val) {
            if (val) {
              this.quotas = val
            } else {
              this.quotas = []
            }
          },
          saveQuotas() {
            if (!this.validateQuotas()) {
              return
            }
            let that = this
            this.$http.post(QUOTAS_API + '/' + this.$props.campaignId, this.convertFromUiQuotas(this.quotas), { headers: this.prepareSecurityHeader() })
              .then((response) => {
                that.openNotificationWithType('info', 'Квоты сохранены.')
                that.setQuotas(this.convertToUiQuotas(response.data.quotas))
              }).catch((error) => {
                console.log(error)
                that.openNotificationWithType('danger', 'Ошибка сохранения квот.')
              })
          },
          validateQuotas() {
            for (let i = 0; i < this.quotas.length; i++) {
              if (!this.quotas[i].limit && this.quotas[i].limit !== 0) {
                this.openNotificationWithType('warning', 'Заполните лимиты')
                return false
              }
              for (let j = 0; j < i; j++) {
                if (this.quotas[i].gender === this.quotas[j].gender && this.isQuotaIntersect(this.quotas[i], this.quotas[j])) {
                  this.openNotificationWithType('warning', (j + 1) + ' и ' + (i + 1) + ' квоты пересекаются')
                  return false
                }
              }
            }
            return true
          },
          isQuotaIntersect(quota1, quota2) {
            let age1 = {
                start: Array.isArray(quota1.age) ? quota1.age[0] : quota1.age,
                finish: this.isRange(quota1.age) ? quota1.age[1] : 100
            }
            let age2 = {
              start: Array.isArray(quota2.age) ? quota2.age[0] : quota2.age,
              finish: this.isRange(quota2.age) ? quota2.age[1] : 100
            }

            return !((age1.start > age2.finish || age1.finish < age2.start) && (age2.start > age1.finish || age2.finish < age1.start))
          },
          loadQuotas() {
            let that = this
            this.$http({
              url: QUOTAS_API + '/' + this.$props.campaignId,
              headers: this.prepareSecurityHeader()
            }).then((response) => {
              that.setQuotas(this.convertToUiQuotas(response.data.quotas))
            }).catch((error) => {
              console.log(error)
              if (error.response.status === 504 || error.response.status === 404) {
                this.$emit('serviceNotAvailable')
              }
            })
          },
          convertToUiQuotas(dataQuotas) {
            let quotas = []
            for (let key in dataQuotas) {
              let quota = {}
              let quotaSplit = key.split('_')
              quota.gender = quotaSplit[0] !== 'M'
              if (parseInt(quotaSplit[1])) {
                quota.age = [parseInt(quotaSplit[1]), parseInt(quotaSplit[2])]
              } else {
                quota.age = [parseInt(quotaSplit[2])]
              }
              quota.limit = dataQuotas[key]
              quotas.push(quota)
            }
            return quotas
          },
          convertFromUiQuotas(dataQuotas) {
            let quotas = {}
            for (let i = 0; i < dataQuotas.length; i++) {
              let quotaStr = ''
              quotaStr = !dataQuotas[i].gender ? 'M_' : 'F_'
              if (this.isRange(dataQuotas[i].age)) {
                quotaStr += (dataQuotas[i].age[0] + '_' + dataQuotas[i].age[1])
              } else {
                let ageStart = Array.isArray(dataQuotas[i].age) ? dataQuotas[i].age[0] : dataQuotas[i].age
                quotaStr += ('GTE_' + ageStart)
              }
              quotas[quotaStr] = dataQuotas[i].limit
            }
            return quotas
          },
          addQuota() {
            let preferQuota = this.preferQuota(this.quotas)
            this.quotas.push(preferQuota)
            this.$emit('set', this.quotas)
          },
          preferQuota(quotasList) {
            if (quotasList && quotasList.length) {
              let lastQuota = quotasList[quotasList.length - 1]
              if (this.isRange(lastQuota.age) && lastQuota.age[1] < this.quotasParam.maxAge) {
                let firstAge = lastQuota.age[1] + 1
                let lastAge = firstAge + lastQuota.age[1] - lastQuota.age[0]
                let newQuota = {
                  age: [firstAge, lastAge],
                  gender: lastQuota.gender
                }
                if (newQuota.age[1] > this.quotasParam.maxAge) {
                  newQuota.age = [newQuota.age[0], this.quotasParam.maxAge]
                }
                return newQuota
              } else {
                return {
                  age:[18, 24],
                  gender: !lastQuota.gender
                }
              }
            }
            return {
              age:[18, 24],
              gender: false
            }
          },
          getQuotaDivClass(quota, index) {
            let divClass = !quota.gender ? 'm' : 'f'
            if (!this.isRange(quota.age)) {
              divClass += ' gte'
            }
            divClass += (index % 2 === 1 ? ' uneven' : ' even')
            return divClass
          },
          getSliderRailStyle(quota) {
            if (this.isRange(quota.age)) {
              return null
            } else {
              return {
                'background-color': !quota.gender ? '#3498db' : '#db6086'
              }
            }
          },
          getSliderTooltipStyle(quota) {
            if (!quota.gender) {
              return null
            } else {
              return {
                'background-color': '#db6086',
                'border-color': '#db6086'
              }
            }
          },
          getSliderProcessStyle(quota) {
            if (this.isRange(quota.age)) {
              if (!quota.gender) {
                return null
              } else {
                return {
                  'background-color': '#db6086'
                }
              }
            } else {
              return {
                'background-color': '#ccc'
              }
            }
          },
          toggleHighLimit(range, quota) {
            if (!range && this.isRange(quota.age)) {
              quota.age = [quota.age[0]]
            } else if (range && !this.isRange(quota.age)) {
              let ageStart = Array.isArray(quota.age) ? quota.age[0] : quota.age
              quota.age = [ageStart, ageStart + 10]
            }
            console.log(quota.age)
          },
          getQuotaSummary(quota) {
            let summary = !quota.gender ? 'Мужчины' : 'Женщины'
            if (this.isRange(quota.age)) {
              summary += (' от ' + quota.age[0] + ' до ' + quota.age[1] + ' ' + this.yearFormat(quota.age[1]))
            } else {
              let ageStart = Array.isArray(quota.age) ? quota.age[0] : quota.age
              summary += (' старше ' + ageStart + ' ' + this.yearFormat(ageStart))
            }
            if (quota.limit || quota.limit === 0) {
              summary += ('.  Лимит: ' + quota.limit)
            }
            return summary
          },
          yearFormat(year) {
            if (year !== 11 && year % 10 === 1) {
              return 'года'
            } else {
              return 'лет'
            }
          },
          isRange(age) {
            return Array.isArray(age) && age.length === 2
          }
        }
    }
</script>

<style scoped>
  .quotas{
    margin-bottom: 16px;
  }
  .stats{
    margin-top: 16px;
  }
  .save {
    margin-top: 64px;
  }
  .rangesList .age {
    min-width: 630px;
    max-width: 1400px;
    width: 60%;
    margin-left: 16px;
    margin-right: 16px;
  }
  .rangesList .limit {
    min-width: 80px;
    max-width: 120px;
    width: 5%;
    vertical-align: middle;
    margin-left:8px;
  }
  .rangesList .summary {
    vertical-align: super;
    /*margin-bottom: 15px;*/
    margin-left:32px;
  }
  .rangesList .highLimit {
    position: absolute;
    width: 120%;
    margin-top: 20px;
    float: right;
    margin-left: auto;
    margin-right: auto;
    left: 56%;
  }
  .rangesList .highLimit span {
    margin-right:4px;
  }

  .rangesList .m .switch {
    background-color: #3498db;
    border-color: #3498db;
  }
  .rangesList .m .switch:before {
    background-color: #3498db;
    border-color: #3498db;
  }

  .rangesList .switch {
    font-family: 'Font Awesome 5 Free';
    font-weight: 900;
    -webkit-font-smoothing: antialiased;
    display: inline-block;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    line-height: 1;
    --height: 2.2rem;
  }
  .rangesList .f .switch:after {
    content: '\f182';
    padding-left: 7px;
    padding-top: 3px;
  }
  .rangesList .m .switch:after {
    content: '\f183';
    padding-left: 7px;
    padding-top: 3px;
  }
  .rangesList .is-medium.switch:after {
    font-size: x-large;
    padding-left: 8px;
    padding-top: 2px;
  }
  .quota {
    /*margin-top: 36px;*/
    /*margin-bottom: 36px;*/
    padding-top: 36px;
    padding-bottom: 36px;
  }
  .quota.even {
    background-color: #fafafa;
  }
</style>



// WEBPACK FOOTER //
// CampaignQuota.vue?01c0e751